import React, { useCallback, useEffect, useState } from "react";
import { Autocomplete, Value } from "@material-ui/lab";
import { useBoolean } from "../../hooks/utils/useBoolean";
import { TextField } from "@material-ui/core";
import { Asset, Instrument } from "../../api/api";
import { useTradableAssets } from "../../hooks/useTradableAssets";

export interface AutocompleteClientTradableInstrumentsProps {
  value                     : Instrument | null
  hiddenInstrumentIDs?      : Set<number>
  clientTradableInstruments : Instrument[] | undefined
  onChange?                 : (c: Instrument|null) => void;
}

export const AutocompleteClientTradableInstruments = (p: AutocompleteClientTradableInstrumentsProps) => {
  const { tradableAssets }                                          = useTradableAssets(),
        [ open, onOpen, onClose ]                                   = useBoolean(),
        [ query, setQ ]                                             = useState(""),
        [ displayInstruments, setDisplayInstruments ]               = useState<Instrument[]>(),
        [ assetIdMap, setAssetIdMap ]                               = useState<{[assetId: number]: Asset}>({});

  const onChange = useCallback(
    (e: React.ChangeEvent<{}>, value: Value<Instrument, false, false, false>) => {
      if (p.onChange) {
        p.onChange(value);
      }
    },
    [p]
  );

  useEffect( () => {
    if (tradableAssets !== undefined) {
      var newAssetIdMap: {[assetId: number]: Asset} = {};
      for (let i = 0; i < tradableAssets.length; i++) {
        newAssetIdMap[tradableAssets[i].id] = tradableAssets[i]
      }
      setAssetIdMap({...newAssetIdMap});
    }
  }, [ tradableAssets, setAssetIdMap ])

  useEffect( () => {
    if (tradableAssets && p.clientTradableInstruments) {
      setDisplayInstruments(p.clientTradableInstruments.filter((inst: Instrument) => {
        if (p.hiddenInstrumentIDs) {
          return !p.hiddenInstrumentIDs.has(inst.instrumentId);
        }
        return true
      }).map((inst: Instrument) => {
        return {
          ...inst,
          ticker: (inst.ticker !== undefined) ?
                      inst.ticker! :
                      (inst.contraAssetId !== undefined && inst.contraAssetId !== 0) ?
                          (assetIdMap[inst.assetId]?.ticker + '/' + assetIdMap[inst.contraAssetId]?.ticker) :
                          assetIdMap[inst.assetId]?.ticker
        }
      }));
    }
    
  }, [ p.hiddenInstrumentIDs, tradableAssets, p.clientTradableInstruments, assetIdMap ]);

  console.log("Rendering Autocomplete Tradable Instruments")

  return (
    <>
      {displayInstruments !== undefined && <Autocomplete<Instrument>
        onChange={onChange}
        value={p.value}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        getOptionSelected={(option, value) => option.instrumentId === value.instrumentId}
        getOptionLabel={(option) => (option.ticker) ? option.ticker : ''}
        options={displayInstruments}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Instrument"
            variant="outlined"
            value={query}
            onChange={(e) => setQ(e.target.value)}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />}
    </>
  );
};
